// hooks/useTourSSE.js
import { useEffect, useRef, useState } from "react";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:4000/api";
const MAX_RECONNECT_DELAY = 30000;

// hooks/useTourSSE.js 수정
// tourId별로 연결하는 대신 전체 업데이트를 한 SSE로 받기
export function useTourSSE(onUpdate) {
  const onUpdateRef = useRef(onUpdate);
  const [status, setStatus] = useState("connecting");

  useEffect(() => {
    onUpdateRef.current = onUpdate;
  }, [onUpdate]);

  useEffect(() => {
    let eventSource = null;
    let reconnectTimer = null;
    let reconnectAttempt = 0;
    let disposed = false;

    const connect = () => {
      if (disposed || !navigator.onLine) {
        if (!disposed) setStatus("offline");
        return;
      }

      setStatus(reconnectAttempt === 0 ? "connecting" : "reconnecting");
      eventSource = new EventSource(`${BASE_URL}/tours/sse`);

      eventSource.onopen = () => {
        reconnectAttempt = 0;
        setStatus("connected");
      };

      eventSource.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          if (data.tourId == null || data.participantCount == null) return;
          onUpdateRef.current(data.tourId, data.date, data.participantCount);
        } catch (error) {
          console.error("Invalid tour availability event:", error);
        }
      };

      eventSource.onerror = () => {
        eventSource?.close();
        if (disposed) return;

        const delay = Math.min(1000 * 2 ** reconnectAttempt, MAX_RECONNECT_DELAY);
        reconnectAttempt += 1;
        setStatus("reconnecting");
        reconnectTimer = window.setTimeout(connect, delay);
      };
    };

    const reconnectNow = () => {
      window.clearTimeout(reconnectTimer);
      eventSource?.close();
      reconnectAttempt = 0;
      connect();
    };

    connect();
    window.addEventListener("online", reconnectNow);

    return () => {
      disposed = true;
      window.removeEventListener("online", reconnectNow);
      window.clearTimeout(reconnectTimer);
      eventSource?.close();
    };
  }, []);

  return status;
}
